import { render, staticRenderFns } from "./ObservatoryListItem.vue?vue&type=template&id=24755887&scoped=true&"
import script from "./ObservatoryListItem.vue?vue&type=script&lang=js&"
export * from "./ObservatoryListItem.vue?vue&type=script&lang=js&"
import style0 from "./ObservatoryListItem.vue?vue&type=style&index=0&id=24755887&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24755887",
  null
  
)

export default component.exports